<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <div class="row">
            <div class="col-12">
                <TitleComponent 
                    title="1. Renovación de abonos" 
                    subtitle="Renovación de abonos para abonados existentes."
                />
            </div>
            <div class="columna-abono-4">
                <div class="form-group mt-3 d-flex align-items-center">
                    <label class="mr-4 ml-1">FILTROS:</label>
                    <div class="custom-control custom-radio mr-4 ml-1">
                        <input class="custom-control-input" type="radio" id="n_abonado" name="customRadio" value="n_abonado_antiguo" v-model="search_for"/>
                        <label for="n_abonado" class="custom-control-label">Nº Abonado</label>
                    </div>
                    <div class="custom-control custom-radio mr-4 ml-1">
                        <input class="custom-control-input" type="radio" id="dni" name="customRadio" value="dni" v-model="search_for"/>
                        <label for="dni" class="custom-control-label">Dni</label>
                    </div>
                    <div class="custom-control custom-radio mr-4 ml-1">
                        <input class="custom-control-input" type="radio" id="apellidos" name="customRadio" value="apellidos" v-model="search_for"/>
                        <label for="apellidos" class="custom-control-label">Apellidos</label>
                    </div>
                </div>
                <FormInput placeholder="Buscar abonado" name="buscar" id="localidad" rules="required" v-model="search"/>
                <Button type="submit" name="button" class="mt-3">ENVIAR</Button>
            </div>
            <div class="columna-abono-8" v-if="!loading && abonados">
                <h3>RESULTADOS ENCONTRADOS</h3>
                <div class="row lista_abonados" v-if="abonados.length > 0">
                    <div v-for="(abonado, index) in abonados" class="col-12" :key="index">
                        <div class="row">
                            <div class="col-12">
                                <p><strong>{{ abonado.name + ' ' + abonado.surnames }}</strong></p>
                            </div>
                            <div class="col-5">
                                <p>Nº ABONADO: <span class="text-primary">{{ abonado.n_abonado }}</span> / DNI: <span class="text-primary">{{ abonado.dni }}</span></p>
                                <p v-if="abonado.asiento">
                                    <span class="text-primary">{{ abonado.asiento.region }}</span> FILA: <span class="text-primary">{{ abonado.asiento.row }}</span> ASIENTO: <span class="text-primary">{{ abonado.asiento.seat }}</span>
                                </p>
                                <p v-else-if="abonado.plaza">
                                    <span class="text-primary">{{ abonado.plaza.region_name ?? abonado.plaza.section_name }}</span> FILA: <span class="text-primary">{{ abonado.plaza.fila }}</span> ASIENTO: <span class="text-primary">{{ abonado.plaza.butaca }}</span>
                                </p>
                            </div>
                            <div class="col-3">
                                <span v-if="abonado.esta_renovado" class="text-success">
                                    <i class="fas fa-check"></i> 
                                    <template v-if="abonado.n_abonado_antiguo">
                                        RENOVADO
                                    </template>

                                    <template v-else>
                                        NUEVA ALTA
                                    </template>
                                </span>
                                <span v-if="!abonado.tiene_asiento && !abonado.plaza" class="text-danger">SIN ASIENTO</span>
                                <span v-if="!abonado.esta_renovado && !isAsientoDisponible(abonado) && !isPlazaDisponible(abonado)" class="text-danger">ASIENTO NO DISPONIBLE</span>
                                <span v-if="(!abonado.esta_renovado && abonado.tiene_asiento && abonado.asiento.region_disponible) || isPlazaDisponible(abonado)">
                                    <Button @click.prevent="showModal('renovar-' + abonado.id)">RENOVACIÓN RÁPIDA</Button>
                                    <RenovacionRapidaComponent
                                        :abonado="abonado"
                                        :precios="precios"
                                        @close="handleRenovacionClose"
                                        @cambiarAsiento="renovar(abonado)"
                                    />
                                </span>
                            </div>
                            <div class="col-4">
                                <template v-if="abonado.esta_renovado">
                                    <Button :href="abonado.url_imprimir" target="_blank">IMPRIMIR ABONO</Button>
                                </template>
                                <template v-if="!abonado.tiene_asiento && !abonado.plaza">
                                    <Button @click.prevent="seleccionarZona(abonado)">SELECCIONAR ZONA</Button>
                                </template>
                                <template v-if="(abonado.tiene_asiento || abonado.plaza) && !abonado.esta_renovado">
                                    <Button @click.prevent="renovar(abonado)">CAMBIAR ASIENTO / INCLUIR MÁS ABONOS </Button>
                                </template>
                            </div>
                            <div class="col-12" v-if="abonado.observaciones">
                                <small>{{ abonado.observaciones }}</small>
                            </div>
                        </div>
                        <hr/>
                    </div>
                </div>
                <div class="row lista_abonados" v-if="abonados.length == 0">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-12">
                                <p><strong>No hay ningún abono con estos datos.</strong></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-8 text-center" v-if="loading">
                <LoaderComponent/>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
    import TitleComponent from '@/components/backend/stepper/components/TitleComponent';
    import RenovacionRapidaComponent from '@/components/backend/stepper/components/RenovacionRapidaComponent';

    export default {
        props: ['precios'],
        data() {
            return {
                loading: false,
                search: '',
                search_for: 'n_abonado_antiguo',
                abonados: null
            }
        },
        methods: {
            getAbonados : function() {
                this.loading = true;

                const params = {
                    lista_id: this.lista_id,
                    filters : {
                        paginate: 0,
                        [this.search_for]: this.search,
                        renovacion: 1,
                    }
                };

                this.$store.dispatch(this.config.getVuexAlias('back.lista.abonados.renovacion'), params).then(res => {
                    this.abonados = res.data.data;
                }).finally(() => this.loading = false);
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.getAbonados();
                }
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal) {
                this.$modal.hide(modal);
            },
            // Handler for RenovacionRapidaComponent's close event (2026-07-08).
            // The modal may close after either a successful renovation or a
            // cancel. On success, refetch the abonado list so the new
            // state (renovado flag, plazos, etc.) is reflected immediately.
            handleRenovacionClose(payload) {
                this.$modal.hide(payload.modalName);
                if (payload.success) {
                    this.getAbonados();
                }
            },
            renovar(abonado) {
                if (abonado.asiento) {
                    abonado.asiento.seleccionado = true;
                }
                this.$emit('renovar', abonado);
            },
            seleccionarZona(abonado) {
                const incluye = `n_abonado_antiguo=${abonado.n_abonado_antiguo}`;
                if (this.$route.fullPath.includes(incluye)) {
                    this.$toast.error('Selecciona una Zona');
                    return;
                }
                
                this.$router.push({name: 'back.abonos.index', query: {n_abonado_antiguo: abonado.n_abonado_antiguo}});
                this.$emit('seleccionarZona', abonado);
            },
            isPlazaDisponible(abonado) {
                let preciosRenovacion = [];
                if (abonado.plaza) {
                    const precios = abonado.plaza.precios;
                    if (precios && precios.length) {
                        preciosRenovacion = precios.filter(precio => precio.renovacion);
                    }
                }

                return preciosRenovacion.length > 0;
            },
            isAsientoDisponible(abonado) {
                if (abonado.asiento?.region_disponible) {
                    return true;
                }

                return false
            }
        },
        computed: {
            lista_id() {
                return this.$store.getters.getListaId;
            }
        },
        components: {
            TitleComponent, RenovacionRapidaComponent
        }
    }
</script>

<style scoped>
    .lista_abonados {
        overflow: scroll;
        height: 300px
    }
    
    .columna-abono-3, .columna-abono-4, .columna-abono-8 {
        position: relative;
        width: 100%;
        padding-right: 7.5px;
        padding-left: 7.5px;
    }

    .columna-abono-4 {
        -ms-flex: 0 0 33.333333%;
        flex: 0 0 33.333333%;
        max-width: 33.333333%;
    }

    .columna-abono-8 {
        -ms-flex: 0 0 66.666667%;
        flex: 0 0 66.666667%;
        max-width: 66.666667%;
    }

    @media (max-width: 768px) {
        .columna-abono-4 {
            -ms-flex: 0 0 100%;
            flex: 0 0 100%;
            max-width: 100%;
        }

        .columna-abono-8 {
            -ms-flex: 0 0 100%;
            flex: 0 0 100%;
            max-width: 100%;
        }

        .columna-abono-3 {
            -ms-flex: 0 0 100%;
            flex: 0 0 100%;
            max-width: 100%;
        }

        .custom-control-input {
            margin-left: 0px;
        }

        .mr-4 {
            margin-right: 0px !important;
        }
    }
</style>
